// 追溯信息页默认 HTML 模板（供 TraceView / FormModal 共用）
export const DEFAULT_DETAIL_HTML =
`<div class="tt">品种信息</div>
<div class="dl"><span>单元识别代码</span><b>{code}</b></div>
<div class="dl"><span>品种名称</span><b>{product_name}</b></div>
<div class="dl"><span>作物种类</span><b>小麦</b></div>
<div class="dl"><span>种子类别</span><b>大田用种</b></div>
<div class="dl"><span>净含量</span><b>15kg</b></div>
<div class="tt">种子生产经营者</div>
<div class="dl"><span>生产单位</span><b>{company_name}</b></div>
<div class="dl"><span>查询次数</span><b>{scan_count}</b></div>
<div class="dl"><span>首次查询时间</span><b>{first_scan_time}</b></div>
<div class="dl"><span>上次查询时间</span><b>{last_scan_time}</b></div>`
